import * as React from 'react';

function IconExclamationCircle(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.882a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4zm1 9.835a1 1 0 01-2 0v-5a1 1 0 012 0v5zM12 23c6.075 0 11-4.925 11-11 0-6.076-4.925-11-11-11S1 5.924 1 12c0 6.075 4.925 11 11 11z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoIconExclamationCircle = React.memo(IconExclamationCircle);
export default MemoIconExclamationCircle;
